export default __webpack_public_path__ + "static/media/165.cd704f5d.png";